import React from "react";
import { useAuthorization } from "@common/providers";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router";
import Show from "./Show";
import Edit from "./Edit/Edit";
import New from "./New/New";
import {
  useV2GetAccountQuery,
  useV2GetProjectByIdQuery,
} from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";

const TravelAndExpenseV2Mspa = ({ project_id }): JSX.Element => {
  // Get Account
  const {
    data: account,
    error: accountError,
    isLoading: accountLoading,
    refetch: accountRefetch,
  } = useV2GetAccountQuery({
    include: ["phases", "resources"],
  });

  // Get Project with included items
  const {
    data: project,
    error: projectError,
    isLoading: projectLoading,
    refetch: refetchProjectData,
  } = useV2GetProjectByIdQuery({
    id: String(project_id),
    include: [
      "project-phases",
      "payment-term",
      "project-resources",
      "project-services",
      "rate-table",
    ],
  });

  // Get permissions for current user
  const { accessLevel, privilegesLoading, user } = usePrivilegeCheck();

  const authorized = useAuthorization();
  if (
    !authorized ||
    !account ||
    accountLoading ||
    !user ||
    privilegesLoading ||
    !project ||
    projectLoading
  ) {
    return <ScopeStackSpinner />;
  }

  const permission = accessLevel("projects.travel_and_expense");

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            project_id={project_id}
            account={account}
            permission={permission}
            project={project}
          />
        }
      />
      <Route
        path="/edit/:expenseId"
        element={
          <Edit
            project_id={project_id}
            account={account}
            permission={permission}
            project={project}
          />
        }
      />
      <Route
        path="/new"
        element={
          <New
            project_id={project_id}
            account={account}
            permission={permission}
            project={project}
          />
        }
      />
    </Routes>
  );
};

export default TravelAndExpenseV2Mspa;
